import { Component, h, Prop } from '@stencil/core';

@Component({
    tag: 'rentware-radio',
    styleUrl: 'style.sass',
    shadow: false,
})

export class RentwareRadio {
    @Prop() id: string;
    @Prop() name: string;
    @Prop() value: string;
    @Prop() label?: string;
    @Prop() labelEnd?: string;
    @Prop() labelHtml?: string;
    @Prop() checked: boolean;
    @Prop() placeholder?: string;
    @Prop() disabled?: boolean;
    @Prop() required?: boolean;
    @Prop() onInput?: any;
    @Prop() onBlur?: any;
    @Prop() onFocus?: any;
    @Prop() inputRef?: any;
    @Prop() inputUnRef?: any;
    @Prop() error: boolean = false;
    inputInternalRef?: any;

    disconnectedCallback() {
        if (this.inputUnRef) {
            this.inputUnRef(this.inputInternalRef, this.name);
        }
    }

    get containerClass() {
        return this.error ? "RadioContainer ContainerError" :
            this.disabled ? "RadioContainer RadioContainerDisabled" :
                "RadioContainer ";
    }

    get boxClass() {
        return this.error ? "RadioField Error" :
            this.disabled ? "RadioField RadioFieldDisabled" :
                "RadioField ";
    }

    get labelClass() {
        return this.checked && "Label Selected" || "Label";
    }

    render() {
        return (
            <label class={this.containerClass} >
                <input
                    type="radio"
                    id={this.id}
                    name={this.name}
                    checked={this.checked}
                    value={this.value}
                    placeholder={this.placeholder}
                    disabled={this.disabled}
                    required={this.required}
                    onBlur={this.onBlur}
                    onFocus={this.onFocus}
                    onInput={this.onInput}
                    ref={(el: HTMLInputElement) => {
                        this.inputInternalRef = el;
                        if (this.inputRef) {
                            this.inputRef(el);
                        }
                    }}
                />

                <div class={this.boxClass}>
                    <svg width="4" height="4" viewBox="0 0 4 4" xmlns="http://www.w3.org/2000/svg">
                        <rect width="4" height="4" rx="2" />
                    </svg>
                </div>

                {this.label &&
                    <div class={this.labelClass}>
                        <span>{this.labelEnd}</span>
                        <span>{this.label}&nbsp;</span>
                    </div>
                }

                {this.labelHtml &&
                    <span
                        class={this.labelClass}
                        innerHTML={this.labelHtml}
                    />
                }

            </label>
        );
    }

}
